module.exports = __webpack_public_path__ + "static/media/up-arrow-blue.5168a972.svg";